<div class="mt-container-box">
    <div class="header flex-row">
        <ng-content select="[slot=header-start]"></ng-content>

        <div *ngIf="title" class="title" [ngClass]="{ 'no-subtitle' : !subtitle }">
            {{title}}
        </div>

        <div *ngIf="subtitle" class="subtitle">
            {{subtitle}}
        </div>

        <ng-content select="[slot=header-end]"></ng-content>
    </div>

    <div class="mt-content-box">
        <ng-content select="[slot=content]"></ng-content>
    </div>
</div>